var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipGoldFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6847_89935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7617 2.02998L14.9101 5.77077C14.3502 6.31454 13.6005 6.61871 12.82 6.61871H9.62963C7.97278 6.61871 6.62963 7.96185 6.62963 9.6187V13.0721C6.62963 13.9111 6.27832 14.7117 5.66093 15.2798L3.33533 17.4196C2.06734 18.5863 2.04045 20.5789 3.2765 21.7793L6.22411 24.6421C6.85713 25.2569 7.18737 26.1193 7.12694 26.9996L6.84966 31.0392C6.73066 32.7728 8.10489 34.2446 9.84262 34.2446H13.9601C14.7673 34.2446 15.5404 34.5698 16.1047 35.1469L18.8118 37.9144C19.9476 39.0756 21.8012 39.1219 22.9936 38.019L26.2117 35.0423C26.7661 34.5295 27.4936 34.2446 28.2488 34.2446H32.6667C34.3235 34.2446 35.6667 32.9015 35.6667 31.2446V26.746C35.6667 26.0149 35.9336 25.309 36.4174 24.7609L39.1074 21.7128C40.167 20.5123 40.0969 18.6912 38.9483 17.5756L36.5765 15.2722C35.9949 14.7073 35.6667 13.931 35.6667 13.1201V9.61871C35.6667 7.96185 34.3235 6.61871 32.6667 6.61871H28.8837C28.1032 6.61871 27.3535 6.31454 26.7936 5.77076L22.942 2.02998C21.7779 0.899394 19.9258 0.899396 18.7617 2.02998Z",
    fill: "url(#paint0_linear_6847_89935)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.544 27.224C24.176 27.224 25.584 26.6 26.384 25.8V20.472H22.16V22.408H24.272V24.744C23.936 25.016 23.36 25.176 22.784 25.176C20.464 25.176 19.28 23.64 19.28 21.048C19.28 18.52 20.64 16.984 22.624 16.984C23.68 16.984 24.352 17.416 24.944 17.976L26.192 16.456C25.424 15.688 24.24 14.952 22.544 14.952C19.392 14.952 16.864 17.224 16.864 21.128C16.864 25.08 19.328 27.224 22.544 27.224Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6847_89935",
    x: 0.366577,
    y: 1.18213,
    width: 41.4916,
    height: 41.6345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6847_89935"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6847_89935",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6847_89935",
    x1: 6.33333,
    y1: 5.66667,
    x2: 35.6667,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC9245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC986"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipGoldFront);
export default __webpack_public_path__ + "static/media/image__membership-gold--front.fa998992e76eb110203ad628c90c7de6.svg";
export { ForwardRef as ReactComponent };